import { ArrowDownFill, DashedLine } from "@icons";

export function PathIndicator() {
  return (
    <div className="py-2 flex items-center justify-center relative">
      <div className="flex flex-col items-center gap-1">
        <DashedLine className="text-blue-200 rotate-90 h-6 w-6" />
        <div className="btn-flat h-10 w-10 rounded-full bg-white items-center justify-center flex border-2 border-blue-200">
          <span className="sr-only">Arrow Down</span>
          <ArrowDownFill className="w-4 h-4 rotate-180 text-black-400" />
        </div>
        <DashedLine className="text-blue-200 rotate-90 h-6 w-6" />
      </div>
    </div>
  );
}
